<template>
    <div
        class="bg-white flex-shrink-0 flex-grow-0 mb-3 mb-md-0"
        :class="{
            'image-container-sm rounded-sm': size === 'small',
            'image-container-lg rounded-lg shadow-card': size === 'large',
        }"
    >
        <img
            v-if="caseObj.cover_image"
            :src="caseObj.cover_image.signed_url"
            class="case-image w-100 h-100"
            :alt="'Cover image for scenario titled ' + caseObj.title"
            :class="{ 'rounded-lg': size === 'large', 'rounded-sm': size === 'small' }"
        />
        <div
            v-else
            class="d-flex w-100 h-100 align-items-center justify-content-center cover-placeholder"
            :class="{ 'rounded-lg': size === 'large', 'rounded-sm cover-small': size === 'small' }"
        >
            <span class="px-2 font-weight-bold text-center">{{ coverPlaceholderTitle }}</span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import Utilities from "@/assets/js/utilities.js"

export default {
    name: "LibraryCaseCard",
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: "large",
        },
    },
    computed: {
        coverPlaceholderTitle() {
            let maxLength = this.size === "small" ? 12 : 40
            return Utilities.trimString(this.caseObj.title, maxLength)
        },
    },
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import "@/assets/styles/variables.scss";

.image-container-lg {
    height: $lib-item-height;
    width: $lib-item-width;
}

.image-container-sm {
    height: $lib-item-height-sm;
    width: $lib-item-width-sm;
}

.case-image {
    object-fit: cover;
}

.cover-placeholder {
    overflow: hidden;
}

.cover-small {
    scale: math.div($lib-item-height-sm, $lib-item-height) * 1.5;
}

.shadow-card {
    box-shadow: 0 0.1rem 0.4rem rgba($black, 0.075);
}
</style>